import { NoBacktestIcon } from "assets/icons/index";
import { NoBacktestContainer } from "features/Strategy/v2/Detail/StrategyDetails.styles";
import React from "react";
import { SubHeading } from "style/components/SubHeading.styles";

export const NoBacktest = () => {
  return (
    <NoBacktestContainer>
      <NoBacktestIcon />
      <SubHeading>No Backtest has been made</SubHeading>
      <p>
        Enter the period, simulated amount, and slippage to run your backtest.
        Or just pick one of the ready-made templates.
      </p>
    </NoBacktestContainer>
  );
};
